import { z } from 'zod';

export const SCreateCustomerConversationRequest = z.object({
  user_id: z.number(),
});
export type TCreateCustomerConversationRequest = z.infer<
  typeof SCreateCustomerConversationRequest
>;
